import { Link } from 'react-router-dom';

interface CommunityCardProps {
  title: string;
  summary: string;
  image: string;
  focus?: string[];
  linkTo?: string;
}

export default function CommunityCard({ title, summary, image, focus, linkTo }: CommunityCardProps) {
  return (
    <article className="group flex h-full flex-col">
      <div className="aspect-[4/5] w-full overflow-hidden rounded-[12px] bg-background-100">
        <img
          src={image}
          alt={`${title} managed with care`}
          title={`${title} - residential property management`}
          className="h-full w-full object-cover object-center transition-transform duration-[320ms] [transition-timing-function:cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.035] motion-reduce:transform-none"
        />
      </div>
      <div className="flex flex-1 flex-col pt-5">
        <h3 className="font-heading text-[20px] font-semibold leading-[1.2] text-foreground-950 sm:min-h-[2.4em] md:text-[24px]">{title}</h3>
        <p className="mt-3 text-[16px] leading-[1.6] text-foreground-700">{summary}</p>
        <div className="mt-auto flex flex-col pt-4">
          {focus && (
            <ul className="border-t border-background-200">
              {focus.map((f) => (
                <li key={f} className="border-b border-background-200 py-2.5 text-[15px] text-foreground-950">{f}</li>
              ))}
            </ul>
          )}
          {linkTo && (
            <Link
              to={linkTo}
              className="inline-flex min-h-[48px] cursor-pointer items-center gap-2 whitespace-nowrap pt-3 font-label text-[15px] font-semibold text-accent-500 hover:text-accent-700"
            >
              Learn more
              <span className="flex h-4 w-4 items-center justify-center"><i className="ri-arrow-right-line" aria-hidden="true"></i></span>
            </Link>
          )}
        </div>
      </div>
    </article>
  );
}